<template>
  <div class="dashboard__wrapper" :class="routeName">
    <slot name="before-content"></slot>
    <div class="dashboard__wrapper-inner">
      <slot></slot>
      <!-- Card Dialog -->
      <RouterModal />
    </div>
  </div>
</template>

<script>
// Components
import RouterModal from 'Components/RouterModal'

export default {
  name: 'DashboardLayout',

  components: {
    RouterModal,
  },

  data() {
    return {
      routeName: this.$route.name,
    }
  },
}
</script>

<style scoped></style>
